const routes = {
  home: "/",
  chats: "/chats",
  agents: "/agents",
  users: "/users",
  convsList: "/convs-list", // used in mobile view
  login: "/login",
  forgetPassword: "/forget-password",
  oneTimeVerification: "/one-time-verification",
};

export default routes;
